import { render } from "./BackNoticePage.vue?vue&type=template&id=63d43daa&scoped=true"
import script from "./BackNoticePage.vue?vue&type=script&lang=js"
export * from "./BackNoticePage.vue?vue&type=script&lang=js"

import "./BackNoticePage.vue?vue&type=style&index=0&id=63d43daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d43daa"]])

export default __exports__